import React from 'react'

export default ({ children }) => (
  <div style={{}}>{children}</div>
)



// WEBPACK FOOTER //
// ./src/components/container.js